import { useAppSelector } from "@app/hooks";
import { isAlpInvestReportingEntitledFund } from "@reporting/utils/isAlpInvestReportingEntitledFund";
import { entitledFundsSelector } from "@store/Entities/selectors";

export const useAlpInvestEntitleDataValidaion = () => {
  const entitledFunds = useAppSelector(entitledFundsSelector);
  const alpnvestFunds = entitledFunds.data;

  if (!alpnvestFunds) return;

  const hasAlpInvestReportingFunds = Object.values(alpnvestFunds).some(isAlpInvestReportingEntitledFund);

  return hasAlpInvestReportingFunds;
};
